<template>
  <transition name="product">
    <div class="scan-detail">
      <van-nav-bar
        @click-left="onClickLeft"
        :title="title"
        left-text="返回"
        left-arrow
      >
      </van-nav-bar>
      <figure style="margin-bottom: 0">
        <div class="chart-wrapper" style="height: 350px; width:100%">
          <v-chart
            ref="echartBar10"
            id="echartbar"
            type="bar"
            :options="echartBar10"
            :series="echartBar10.series"
            :autoresize="true"
          ></v-chart>
        </div>
      </figure>
    </div>
  </transition>
</template>

<script>
import { echartBar10, toThousands } from "./config";
export default {
  data() {
    return {
      title: "",
      echartBar10: echartBar10,
      e10_2_list: [],
      e10_2_tbColumnConf: [
        {
          title: "项目名称",
          field: "projectName",
        },
        {
          title: "年份",
          field: "taxYear",
        },
        {
          title: "营收计划(万元)",
          field: "income",
        },
        {
          title: "税率",
          field: "taxRate",
        },
        {
          title: "区级税率",
          field: "areaTaxRate",
        },
        {
          title: "是否完成",
          field: "completedtxt",
        },
      ],
    };
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
  },
  created() {
    let query = this.$route.query;
    this.title = query.companyName + query.e10_1_year + "年营收数据";

    this.request({
      url: "/v1.0/company/getCompanyReportAllProByYear",
      method: "POST",
      params: {
        pids: query.pids,
        year: query.e10_1_year,
        companyId: query.id,
      },
    }).then((res) => {
      if (res.success) {
        if (res.data && res.data.length > 0) {
          let Income = [
            {
              value: res.data[0].income,
              year: query.e10_1_year,
            },
          ];
          let CompletedIncome = [
            {
              value: res.data[0].completedIncome,
              year: query.e10_1_year,
            },
          ];
          let yAxis = [query.e10_1_year + "年"];

          this.echartBar10.yAxis.data = yAxis;
          this.echartBar10.series[0].data = Income;
          this.echartBar10.series[1].data = CompletedIncome;
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.scan-detail {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}

.item {
  margin-top: 10px;
}

.fontstyle {
  font-size: 14px;
  color: #646566;
}
.fontstyleS {
  font-size: 14px;
}

.comWrapper {
  width: 100%;
  padding: 10px;
  .comWrapper-wrapper {
    span {
      display: inline-block;
      width: 8px;
      height: 12px;
      background: #1989fa;
    }
  }
}

.van-cell__value {
  flex: 4;
  text-align: left;

  &.center {
    text-align: center;
  }
}

.van-cell {
  padding: 10px 12px;
}

.mycs.badge-warning {
  color: #33333393 !important;
  background-color: #ffc10766 !important;
}
.badge {
  font-weight: 600;
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.coll2 .van-cell {
  padding: 10px 0;
}
.coll2 .van-cell__value {
  flex: 1.8;
  margin-left: 8px;
}
.title-text {
  color: #323233;
  font-weight: 500;
}

.titled-text {
  color: #646566;
  font-size: 14px;
}

button {
  border: 1px solid #1779cc;
  border-radius: 2em;
  background-color: #fff;
  color: #1779cc;
  cursor: pointer;
  font: inherit;
  transition: opacity 0.3s;

  &:focus {
    outline: none;
    box-shadow: 0 0 1px #4fc08d;
  }

  &:active {
    background: rgba(79, 192, 141, 0.2);
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.round {
    width: 1.6em;
    height: 1.6em;
    position: relative;

    &::before, &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 9px;
      height: 1px;
      background-color: #42b983;
    }

    &::after {
      width: 1px;
      height: 9px;
    }

    &.expand::after {
      display: none;
    }
  }
}

figure {
  display: inline-block;
  position: relative;
  margin: 2em auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0 0 45px rgba(0, 0, 0, 0.2);
  padding: 1.5em 2em;
  min-width: calc(40vw + 4em);

  .echarts {
    // width 40vw
    width: 100%;
    min-width: 400px;
    height: 300px;
  }
}

#logo {
  display: inline-block;
  width: 128px;
  height: 128px;
  pointer-events: none;
}

@media (max-width: 980px) {
  p {
    display: flex;
    justify-content: center;

    select {
      text-indent: calc(50% - 1em);
    }

    select, label {
      border: 1px solid #4fc08d;
      border-radius: 2em;
      background-color: #fff;
      color: #42b983;
      cursor: pointer;
      transition: opacity 0.3s;
    }

    button, input, select, label {
      flex: 1 0;
      margin: 0 0.5em;
      padding: 0;
      line-height: 2.4em;
      max-width: 40vw;
      border-radius: 2px;
      font-size: 0.8em;
    }

    select {
      -webkit-appearance: none;
    }

    input[type='checkbox'] {
      display: none;

      &:checked + label {
        background: #42b983;
        color: #fff;
      }
    }
  }

  figure {
    width: 100vw;
    margin: 1em auto;
    padding: 0 1em;
    border: none;
    border-radius: 0;
    box-shadow: none;

    .echarts {
      width: 100%;
      min-width: 0;
      height: 75vw;
    }
  }
}

.renderer {
  position: fixed;
  top: 10px;
  left: 10px;
  font-size: 12px;
  text-align: center;

  button {
    float: left;
    position: relative;
    width: 48px;
    border-radius: 4px;

    &.active {
      z-index: 1;
      background-color: #4fc08d;
      color: #fff;
    }

    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:last-child {
      left: -1px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>